import { Button } from '@material-ui/core'
import { Provider as ErrorsStateContextProvider } from '@/hooks/ErrorsStateContext'
import { Provider as InputStateContextProvider } from '@/hooks/inputStateContext'
import { makeStyles } from '@material-ui/core/styles'
import { useImmer } from 'use-immer'
import React from 'react'
import _ from 'lodash'

import { actions, useDispatch } from '@/redux'
import { useMerchant } from '@/hooks/merchantContext'
import Dialog from '@/components/Dialog'
import MerchantSearch from '@/components/MerchantSearch'

const initialState = {
  source: '',
}

/**
 *
 * @param {*} props
 * @returns
 */
export default function CopyToBetaDialog (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const [errors, setErrors] = React.useState({})
  const [merchantState, setMerchant] = useMerchant()
  const [inputState, setInputState] = useImmer({})
  const [source, setSource] = React.useState()
  const updateInputState = (path, value) => {
    setInputState((draft) => {
      _.set(draft, path, value)
    })
  }

  // const validateInput = React.useCallback(() => {
  //   if (!merchantState) {
  //     return false
  //   }

  //   const temp = {}
  //   if (!_.isEmpty(temp)) {
  //     setErrors(temp)

  //     let message = ''
  //     if (_.size(temp) === 1) {
  //       message = _.map(temp, message => `* ${message}`)
  //     } else {
  //       message = _
  //         .chain(temp)
  //         .pickBy() // // pickBy() 預設使用 _.identity 來 pick，要注意的是這也會把 object 中任何 falsy value 給去掉，在這個情況是允許使用的，因為 temp 裡面只會有 string 或 undefined
  //         .map(message => `* ${message}`)
  //         .uniq() // 去除重複的錯誤訊息
  //         .join('\n')
  //         .value()
  //     }

  //     dispatch(actions.app.toggleDialog('alertDialog', true, {
  //       title: 'Error',
  //       content: message,
  //     }))

  //     return false
  //   } else {
  //     return true
  //   }
  // }, [inputState, merchantState])

  React.useEffect(() => {
    setInputState((draft) => {
      // 初始 inputState
      const newState = {
        ...initialState,
      }
      return newState
    })
  }, [])

  const open = merchantState.openCopyToBetaDialog

  const handleClose = () => {
    setMerchant('openCopyToBetaDialog', false)
    setErrors({})
  }

  const handleSubmit = async () => {
    if (!inputState.source) return
    try {
      await dispatch(actions.merchant.copyToBeta(inputState.source))
      dispatch(actions.app.toggleDialog('alertDialog', true, { title: 'message', content: 'ok' }))
    } catch (error) {
      dispatch(actions.app.toggleDialog('alertDialog', true, { title: 'Error', content: error.message }))
    } finally {
      handleClose()
    }
  }

  return (
    <InputStateContextProvider value={[inputState, updateInputState]}>
      <ErrorsStateContextProvider value={[errors, setErrors]}>
        <Dialog
          title='Copy to Beta'
          open={open}
          handleClose={handleClose}
          renderActions={() => {
            return (
              <Button
                type='submit'
                variant='contained'
                color='primary'
                disableElevation
                onClick={handleSubmit}
              >
                COPY TO BETA
              </Button>
            )
          }}
        >
          <div className={classes.content}>
            Merchant
            <MerchantSearch
              onChange={(o) => {
                setSource(o)
                setInputState({ source: o?.id })
              }}
              value={source}
              onlyRemark={false}
            />
          </div>
        </Dialog>
      </ErrorsStateContextProvider>
    </InputStateContextProvider>
  )
}

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    minHeight: 200,
    padding: 8,
    gap: 8,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    padding: 16,
  },
}))
